import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export const StudioClienti = ({ studio, onSaved }) => {
  const [all, setAll] = useState(null);
  const [sel, setSel] = useState(new Set());
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/admin/companies").then((r) => { setAll(r.data); setSel(new Set(r.data.filter((c) => c.studio_id === studio.id).map((c) => c.id))); });
  }, [studio.id]);
  if (!all) return null;
  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); setSel(n); };
  const save = async () => {
    try { await api.put(`/admin/studios/${studio.id}/clienti`, { company_ids: [...sel] }); toast.success(`${sel.size} aziende assegnate allo studio`); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  const list = all.filter((c) => `${c.denominazione} ${c.piva}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="studio-clienti">
      <div className="mb-3 flex flex-wrap items-center gap-3">
        <Input className="max-w-xs" placeholder="Cerca azienda o P.IVA" data-testid="studio-clienti-search" value={q} onChange={(e) => setQ(e.target.value)} />
        <span className="text-sm text-slate-500" data-testid="studio-clienti-count">{sel.size} assegnate</span>
        <Button className="ml-auto bg-sky-600 hover:bg-sky-700" data-testid="studio-clienti-save" onClick={save}>Salva assegnazioni</Button>
      </div>
      <div className="divide-y divide-slate-100 rounded-lg border border-slate-200">
        {list.length === 0 && <p className="p-4 text-sm text-slate-500">Nessuna azienda</p>}
        {list.map((c) => (
          <label key={c.id} className="flex cursor-pointer items-center gap-3 px-4 py-2.5 hover:bg-slate-50" data-testid={`studio-cliente-${c.id}`}>
            <Checkbox checked={sel.has(c.id)} onCheckedChange={() => toggle(c.id)} data-testid={`studio-cliente-check-${c.id}`} />
            <span className="flex-1"><span className="font-medium text-slate-900">{c.denominazione}</span> <span className="font-mono text-xs text-slate-500">{c.piva}</span></span>
            {c.studio_id && c.studio_id !== studio.id && <span className="text-xs text-amber-700">ora con {c.studio_name}</span>}
          </label>
        ))}
      </div>
    </div>
  );
};
